export default __webpack_public_path__ + "static/media/15year.bbb13623.svg";